var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { TickIcon } from '@shapeable/icons';
import { ImageEntityBackground } from './image-entity-background';
import { CellLabel } from '../elements/cell-label';
import { EntityBubbleImage } from './entity-bubble-image';
import { ContentEntityRichTitle } from './content-entity-rich-title';
import { ContentNode } from './content-node';
import { useLang } from '../hooks/use-lang';
import { trim } from 'lodash';
import { LinkEntityButton } from './link-entity-button';
var cls = classNames('block-thumbnail-card');
export var BlockThumbnailCardDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n   background-blend-mode: hard-light, normal;\n   color: inherit;\n\n   ", "\n\n  "], ["\n   background-blend-mode: hard-light, normal;\n   color: inherit;\n\n   ", "\n\n  "])), function (_a) {
    var hasBackgroundColor = _a.hasBackgroundColor,
      _backgroundColor = _a._backgroundColor;
    return hasBackgroundColor && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n   "], ["\n    background-color: ", ";\n   "])), theme.COLOR(_backgroundColor));
  })
});
var LayoutStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: ", ";\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: ", ";\n    justify-content: space-between;\n  "])), theme.UNIT(5))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    \n    ", "\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    \n    ", "\n\n  "])), theme.UNIT(4), function (_a) {
    var _color = _a._color;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR(_color));
  })
});
var CellLabelStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 12 / 16)
});
var IconContentStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n    gap: ", ";\n  "])), theme.UNIT(4), theme.UNIT(3))
});
var IconContainerStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    \n  "], ["\n    display: flex;\n    align-items: flex-start;\n    \n  "])))
});
var TitleAndContentStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding-top: ", ";\n    line-height: 1;\n  "], ["\n    padding-top: ", ";\n    line-height: 1;\n  "])), theme.UNIT(3))
});
var TitleStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "em;\n    padding-bottom: ", ";\n  "], ["\n    color: ", ";\n    font-size: ", "em;\n    padding-bottom: ", ";\n  "])), theme.COLOR('strong'), 24 / 16, theme.UNIT(6)),
  desktopLarge: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 30 / 16)
});
var ContentStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    color: ", ";\n    line-height: 1.2;\n    font-weight: 300;\n    font-size: ", "em;\n\n  "], ["\n    color: ", ";\n    line-height: 1.2;\n    font-weight: 300;\n    font-size: ", "em;\n\n  "])), theme.COLOR('text'), 12 / 16),
  desktopLarge: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 14 / 16)
});
var LinkButtonStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      \n  "], ["\n      \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(ImageEntityBackground)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled(CellLabel)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), CellLabelStyles),
  IconContent: styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), IconContentStyles),
  Icon: styled(EntityBubbleImage)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  IconContainer: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), IconContainerStyles),
  TitleAndContent: styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TitleAndContentStyles),
  Title: styled(ContentEntityRichTitle)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Content: styled(ContentNode)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  LinkButton: styled(LinkEntityButton)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles)
};
export var BlockThumbnailCard = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    entity = props.entity,
    aspectRatio = props.aspectRatio;
  var content = entity.content,
    icon = entity.icon,
    image = entity.image,
    link = entity.link,
    color = entity.color,
    pretitle = entity.pretitle;
  var backgroundColor = trim(props.backgroundColor || (entity === null || entity === void 0 ? void 0 : entity.backgroundColor) && ((_a = entity === null || entity === void 0 ? void 0 : entity.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) || '#000000');
  var bgColor = "".concat(backgroundColor, "DD") || '#000000';
  var bgColor2 = "".concat(backgroundColor, "BB") || '#000000';
  var firstGradient = "linear-gradient(to bottom, ".concat(bgColor, " 0%, ").concat(bgColor, " 100%)");
  var secondGradient = "linear-gradient(to bottom, ".concat(bgColor2, " 0%, ").concat(bgColor2, " 100%)");
  var baseGradient = "".concat(firstGradient, ", ").concat(secondGradient);
  var hasBackgroundImage = !!image;
  var hasContent = !!content.text;
  var t = useLang();
  var hasLabel = !!pretitle;
  var Icon = !!icon && TickIcon;
  var colorValue = (color === null || color === void 0 ? void 0 : color.value) || 'bright';
  return React.createElement(My.Container, {
    entity: image,
    aspectRatio: aspectRatio,
    baseTopImageStyles: baseGradient,
    landscapeTopImageStyles: baseGradient,
    tabletTopImageStyles: baseGradient,
    desktopTopImageStyles: baseGradient,
    desktopLargeTopImageStyles: baseGradient,
    hasBackgroundColor: !hasBackgroundImage,
    _backgroundColor: backgroundColor,
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.Body, {
    _color: colorValue
  }, hasLabel && React.createElement(My.Label, null, t(pretitle)), React.createElement(My.IconContent, null, !!Icon && React.createElement(My.IconContainer, null, React.createElement(My.Icon, {
    _color: colorValue,
    entity: entity === null || entity === void 0 ? void 0 : entity.icon
  })), React.createElement(My.TitleAndContent, null, React.createElement(My.Title, {
    entity: entity
  }), hasContent && React.createElement(My.Content, {
    entity: content
  })))), !!link && React.createElement(My.LinkButton, {
    entity: link,
    key: link.id,
    variant: 'slim'
  })), children);
};
BlockThumbnailCard.defaultProps = BlockThumbnailCardDefaultProps;
BlockThumbnailCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;